module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inicio'
      }
    }
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('div', {
    staticClass: "logo-header"
  })])]), _vm._v(" "), _vm._m(0)], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-8"
  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
    staticClass: "alert alert-info alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Informação!")]), _vm._v(" " + _vm._s(_vm.leadClient ? 'Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000' : 'Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em breve entraremos em contato para finalizar a adesão, obrigado! ;)\n          ")]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxpayerIdNumber')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "taxpayerIdNumber "
    }
  }, [_vm._v("\n                CNPJ\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxpayerIdNumber),
      expression: "taxpayerIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "name": "taxpayerIdNumber",
      "id": "taxpayerIdNumber",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.taxpayerIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxpayerIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("\n                Empresa\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "companyName",
      "id": "companyName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactName",
      "required": ""
    }
  }, [_vm._v("\n                Nome do Contato\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName",
      "id": "contactName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmail')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactEmail"
    }
  }, [_vm._v("\n                E-mail\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmail",
      "id": "contactEmail",
      "data-vv-rules": "required|email|email:email"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactEmail')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactJobTitle')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactJobTitle"
    }
  }, [_vm._v("\n                Telefone\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.contactJobTitle),
      expression: "contactJobTitle",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|phone'),
      expression: "'required|phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactJobTitle",
      "id": "contactJobTitle"
    },
    domProps: {
      "value": (_vm.contactJobTitle)
    },
    on: {
      "change": function($event) {
        _vm.contactJobTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactJobTitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('sizeOfFleetVehicle')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "sizeOfFleetVehicle"
    }
  }, [_vm._v("\n                Tamanho da Frota\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sizeOfFleetVehicle),
      expression: "sizeOfFleetVehicle"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "sizeOfFleetVehicle",
      "id": "sizeOfFleetVehicle",
      "data-vv-rules": "required|decimal|max:6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.sizeOfFleetVehicle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sizeOfFleetVehicle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block-proposal help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('sizeOfFleetVehicle')))])])]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-header text-center"
  }, [_c('h3', [_vm._v("A melhor solução para a sua frota, mais controle e comodidade para você!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "background-purple"
  }, [_c('div', {
    staticClass: "box-slogan text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotpages/promo-so-falta-sua-empresa/img_so_falta_sua_empresa.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "shadow"
  }, [_vm._v("Com a "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Move Mais")]), _vm._v(" você tem:")])]), _vm._v(" "), _c('div', {
    staticClass: "box-icons text-center"
  }, [_c('div', {
    staticClass: "box-zoom"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotpages/promo-so-falta-sua-empresa/icon_analise_credito.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "bold upper shadow"
  }, [_vm._v("rápida análise "), _c('br'), _vm._v(" de crédito")]), _vm._v(" "), _c('h4', {
    staticClass: "shadow"
  }, [_vm._v("Por que sabemos que sua "), _c('br'), _vm._v(" empresa não tem tempo a perder")])]), _vm._v(" "), _c('div', {
    staticClass: "box-paper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotpages/promo-so-falta-sua-empresa/icon_relatorios_analiticos.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "bold upper shadow"
  }, [_vm._v("relatório analítico "), _c('br'), _vm._v(" de passagens")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "background-arrows"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 color-purple content-text"
  }, [_c('h3', [_vm._v("Informação é o que não falta por aqui.")]), _vm._v(" "), _c('h2', [_vm._v("Extrato definido pelo período que desejar e por placa.")]), _vm._v(" "), _c('h2', {
    staticClass: "bold"
  }, [_vm._v("Você no controle da sua frota.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "content-img",
    attrs: {
      "src": require("../../../static/hotpages/promo-so-falta-sua-empresa/img_print_extrato.png"),
      "alt": ""
    }
  })])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "sac-box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-icon"
  }, [_c('div', {
    staticClass: "sac-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotpages/promo-so-falta-sua-empresa/icon_help_desk.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sac-content"
  }, [_c('h2', [_vm._v("O melhor tempo de resposta do mercado!")]), _vm._v(" "), _c('div', {
    staticClass: "arrow_box"
  }, [_c('h3', [_vm._v("Afinal, seus problemas precisam "), _c('br'), _vm._v(" ser resolvidos o quanto antes!")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticClass: "text-center color-purple bold margin-30"
  }, [_vm._v("Solicite uma proposta. Só falta a sua empresa com a gente:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-4 col-sm-4 pad-fix text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success bold-600 margin-30",
    attrs: {
      "id": "btn-enviar",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                Solicitar proposta\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://movemais.com/"
    }
  }, [_vm._v("Visitar site da Move Mais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "footer text-center"
  }, [_c('small', {
    staticClass: "block"
  }, [_vm._v("Move Mais Meios de Pagamento Ltda. - CNPJ: 15.266.912/0001-87 - Inscrição Estadual: 181.239.134.110")]), _vm._v(" "), _c('small', {
    staticClass: "block"
  }, [_vm._v("Endereço: Avenida Rodrigo Fernando Grillo, 207, Edifício Victoria Business, 9° andar - Araraquara, SP, Brasil - 14801-534")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-03a6807b!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/missing-company.vue
// module id = 2035
// module chunks = 1